export const generateVisuallyHiddenStyles = () => `
  border: 0 !important;
  box-sizing: border-box;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  top: 0;
  width: 1px !important;
`
